import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { consoleLog } from '../../app.helpers';

@Component({
  selector: 'multiDocumentViewer',
  templateUrl: 'multiDocumentViewer.template.html',
  providers: [DialogService]
})
export class MultiDocumentViewerComponent extends BaseComponent implements OnInit, OnDestroy {

  public documentIdentifiers: string[];
  public index: number;
  public windowHash: string;

  constructor(private dialogConfig: DynamicDialogConfig, private dialogRef: DynamicDialogRef, private uiService: UIService,
    private headerService: HeaderActionsService) {

    super();
    this.windowHash = generateRandomIdentifier();
    if (this.dialogConfig?.data) {
      this.documentIdentifiers = this.dialogConfig.data.documentIdentifiers;
    }
    if (!this.documentIdentifiers || this.documentIdentifiers.length < 1) {
      // TODO i18n
      this.uiService.showMessage('Error de configuracion no se ha indicado documento a mostrar');
      this.dialogRef.close();
    } else {
      this.index = 0;
    }
  }

  ngOnInit(): void {
    this.subscribe(this.headerService
      .addWindowAction(
        'General.previous',
        'fas fa-chevron-left',
        'btn-primary',
        true,//() => this.index > 0,
        this.windowHash,
        //() => this.index > 0
        function () {
          return this.index > 0;
        }.bind(this),
      ),
      () => this.previousDocument());
    this.subscribe(this.headerService
      .addWindowAction(
        'General.next',
        'fas fa-chevron-right',
        'btn-primary',
        true, //() => this.index < this.documentIdentifiers.length - 1
        this.windowHash,
        () => this.index < this.documentIdentifiers.length - 1,
      ),
      () => this.index++);
    this.headerService.addWindowDivider(this.windowHash);
    // acción cerrar ventana
    this.subscribe(this.headerService
      .addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => this.dialogRef.close()
    );
  }

  private previousDocument(): number {
    console.log('index-previousDocument-asier: ' + this.index);
    return this.index--;
  }

  ngOnDestroy() {
    this.headerService.clearWindowActions(this.windowHash);
    this.dialogConfig = null;
    this.dialogRef = null;
    super.ngOnDestroy();
  }
}
